// extracted by mini-css-extract-plugin
export var deleteModal = "_gr-0";